import { FrontendConfigGet } from '../generated-client/generated-client';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private readonly defaultFrontendConfig: FrontendConfigGet = {
    environment: 'Development'
  };

  getFrontendConfig(): FrontendConfigGet {
    return window['avaCloudAdminFrontendConfig'] || this.defaultFrontendConfig;
  }
}
